import { observer } from "mobx-react-lite";
import { Box, Button, CircularProgress } from "@mui/material";
import { ProductTypeModel } from "../../../api/models/productType";
import { useStore } from "../../../api/main/appStore";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import MyFormikController from "../../shared/forms/MyFormikController";

interface Props {
  productType: ProductTypeModel | null;
}

export default observer(function CreateOrUpdateProductType({
  productType,
}: Props) {
  const { productTypeStore } = useStore();

  const initialValues = {
    id: productType?.id ?? "",
    name: productType?.name ?? "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Product name is required"),
  });

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) =>
          productType
            ? productTypeStore.updateProductType(values)
            : productTypeStore.createProductType(values)
        }
      >
        {({ values, isSubmitting }) => (
          <Form>
            <MyFormikController
              control="input"
              label="Enter Product Type"
              name="name"
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
              }}
            >
              {isSubmitting ? (
                <CircularProgress color="inherit" />
              ) : productType ? (
                "Modify"
              ) : (
                "Proceed"
              )}
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
});
